export * from "./carousel.component";
